module.exports = __webpack_public_path__ + "assets/img/32.fw.61235246.png";